import { MDSSessionUIState, MDSSessionUIAction } from "./mds-session-context.ui.types";
import { MDSSessionActionTypes } from "../../mds-session-context.types";

export const mdsSessionUiReducer = (
  state: MDSSessionUIState,
  action: MDSSessionActionTypes
): MDSSessionUIState => {
  switch (action.type) {
    case MDSSessionUIAction.SetActiveArtifact:
      return {
        ...state,
        activeArtifact: action.payload,
      };

    case MDSSessionUIAction.SetExtensionFocusState:
      return {
        ...state,
        activeArtifact: null,
      };

    case MDSSessionUIAction.MinimizeSession: {
      return {
        ...state,
        isMinimized: true,
        isCountdownActive: false,
        isPreview: false,
      };
    }

    case MDSSessionUIAction.ExpandSession: {
      return {
        ...state,
        isMinimized: false,
      };
    }

    case MDSSessionUIAction.SetPreviewMode: {
      return {
        ...state,
        isPreview: action.payload,
        isMinimized: false,
      };
    }

    case MDSSessionUIAction.StartCountdown: {
      return {
        ...state,
        countdownDurationMs: action.payload.durationMs,
        isCountdownActive: true,
        isCountdownPaused: false,
      };
    }

    case MDSSessionUIAction.StopCountdown: {
      return {
        ...state,
        isCountdownActive: false,
        isCountdownPaused: false,
      };
    }

    case MDSSessionUIAction.PauseCountdown: {
      return {
        ...state,
        isCountdownPaused: true,
      };
    }

    case MDSSessionUIAction.ResumeCountdown: {
      return {
        ...state,
        isCountdownPaused: false,
      };
    }

    case MDSSessionUIAction.SetNotificationState: {
      return {
        ...state,
        isInNotificationState: action.payload.isInNotificationState,
        notificationInfo: action.payload.notificationInfo || null,
      };
    }

    case MDSSessionUIAction.SetInputFocused: {
      return {
        ...state,
        isInputFocused: action.payload,
      };
    }

    case MDSSessionUIAction.SetHovering: {
      return {
        ...state,
        isHovering: action.payload,
      };
    }

    case MDSSessionUIAction.SetSessionError: {
      return {
        ...state,
        sessionError: action.payload,
      };
    }

    case MDSSessionUIAction.ClearSessionError: {
      return {
        ...state,
        sessionError: null,
      };
    }

    case MDSSessionUIAction.SetSessionPrevMode: {
      return {
        ...state,
        sessionPrevMode: action.payload,
      };
    }

    default:
      return state;
  }
};
